import moment from "moment";
import axios from "axios";
import GraphContent from "@/components/graphContent/graph_content";
import VueStore from "@/store/VueStore";
import CognitoController from "@/common/scripts/cognito_controller";
import { MakeChartData } from "@/common/scripts/chart/make_chart_data";
import { AlertChecker } from "./check_alert";
import { ChartFactory } from "@/common/scripts/chart/chart_factory";
import router from "@/router";
// import GetDataService from "../../../services/get_data_service";
import { RequestParamsMaker } from "./make_request_params";
import { ChartDataSets } from "chart.js";
import { createChartOptions } from "@/common/scripts/chart/create_chart_options";

const lineColors = ["#184FF4", "#F2930C", "#76821A", "#FF5733", "#24262B"];

const switchContent = (self: GraphContent) => {
  self.graphContentArea = true;
  self.graphContent = false;
  self.initSettingArea = true;
  self.settingIcon = true;
};

const displayGraphContent = (self: GraphContent) => {
  self.graphLoading = false;
  self.graphContentArea = true;
};

export async function getSensorData(self: GraphContent) {
  if (VueStore.state.token === null) {
    return router.push("/signIn");
  }
  if (
    self.targetAttribute === null ||
    self.targetPartitionKey === null ||
    self.targetPartitionKey === "" ||
    self.targetAttribute === ""
  ) {
    return;
  }
  try {
    self.canvasID = `graphDrawArea-${self.graphID}`;
    await CognitoController.refreshToken();
    const userID = self.userID;
    const requestParams = RequestParamsMaker.makeGetSensorDataParams(
      self,
      userID
    );
    const apiResponse = await axios(requestParams);
    self.drawGraphError = "";
    self.sensorData = apiResponse.data.res.sensor_data;
    // self.sensorData = await GetDataService.getPastData(self);
    if (self.mst_graph === null) {
      switchContent(self);
    } else {
      const sensorTargetAttribute: string[] = self.targetAttributes;
      const makeChartData = new MakeChartData(self.sensorData);
      const sensorData: number[][] = [];
      sensorTargetAttribute.forEach((attribute: string) => {
        sensorData.push(makeChartData.makeGraphData(attribute));
      });
      if (sensorData.length < 1) {
        displayGraphContent(self);
        return;
      }
      if (sensorData[0].length < 1) {
        displayGraphContent(self);
        return;
      }
      const timeData: string[] = makeChartData.makeTimeData(
        self.sortKey,
        sensorTargetAttribute[0],
        self.timeZone,
        self.graphDateFormat,
        self.timeFormat,
        self.dataTimezone
      );

      self.chartOptions = createChartOptions(self.dynamoRange);
      const labels = sensorTargetAttribute;
      let threshold = self.dynamoThreshold
      const targetAttributes = self.targetAttributes
      if (targetAttributes.length === 1) {
        const thresholdSettings = self.thresholdSettings
        threshold = thresholdSettings[targetAttributes[0]]
      }
      const data: ChartDataSets[] = ChartFactory.createLineChartDatasets(
        labels,
        sensorData,
        self.latestAttributeValues,
        lineColors,
        self.lineType,
        threshold
      );

      self.chartData = ChartFactory.factoryChartData(timeData, data);
      self.latestData = String(
        self.sensorData[self.sensorData.length - 1][self.targetAttribute]
      );
      let latestDataDate: string = String(
        self.sensorData[self.sensorData.length - 1][self.sortKey]
      );
      // 時刻フォーマット文字列内の"/"が特別な文字と認識されてしまうのでハイフンに置換
      if (latestDataDate.includes("/")) {
        latestDataDate = latestDataDate.replace(/\//g, "-");
      }
      if (self.timeFormat === "x") {
        self.latestDataDate =
          moment
            .utc(Number(latestDataDate))
            .utcOffset(self.timeZone)
            .format("YYYY-MM-DD HH:mm:ss") +
          "(" +
          self.timeZone +
          ")";
      } else if (self.timeFormat === "X") {
        self.latestDataDate =
          moment
            .utc(Number(latestDataDate) * 1000)
            .utcOffset(self.timeZone)
            .format("YYYY-MM-DD HH:mm:ss") +
          "(" +
          self.timeZone +
          ")";
      } else if (self.timeFormat.includes("Z")) {
        self.latestDataDate =
          moment(latestDataDate)
            .utcOffset(self.timeZone)
            .format("YYYY-MM-DD HH:mm:ss") +
          " (" +
          self.timeZone +
          ")";
      } else {
        self.latestDataDate =
          moment(latestDataDate)
            .utcOffset(self.dataTimezone, true)
            .utcOffset(self.timeZone)
            .format("YYYY-MM-DD HH:mm:ss") +
          " (" +
          self.timeZone +
          ")";
      }
      AlertChecker.checkAlert(self);
      if (!self.graphContentArea) {
        displayGraphContent(self);
      }
      self.renderingFlag = true;
    }
  } catch (e) {
    self.drawGraphError = self.$t("message.failedToGetLatestData") as string;
    displayGraphContent(self);
    console.error(e);
  }
}
